import { Box, Stack, Typography } from '@mui/material';
import { useLegend, ChartsLabelMark } from '@mui/x-charts-pro';
import { useChartsHighlightContext } from 'components/charts/inc-charts.context';

const HighlightedLegend = () => {
  const { items } = useLegend();
  const { highlightedItem, setHighlightedItem } = useChartsHighlightContext();

  const minHeight = items.length > 14 ? 110 : 40;

  return (
    <Box
      component="ul"
      display="flex"
      p={1}
      m={0}
      alignItems="center"
      justifyContent="center"
      maxHeight={110}
      minHeight={minHeight}
      overflow="auto"
      rowGap={1}
      columnGap={2}
      sx={{ listStyle: 'none', flexFlow: 'wrap' }}
    >
      {items.map(item => (
        <Stack
          component="li"
          key={item.id}
          direction="row"
          spacing={0.5}
          alignItems="center"
          onMouseOver={() => {
            setHighlightedItem({ seriesId: item.id } as any);
          }}
          onMouseOut={() => {
            setHighlightedItem(null);
          }}
          sx={{ cursor: 'pointer' }}
        >
          <ChartsLabelMark type={item.markType} color={item.color} />
          <Typography
            sx={{
              display: 'inline-block',
              fontWeight:
                item.id === highlightedItem?.seriesId ? 'bold' : 'normal',
              opacity:
                !!highlightedItem && item.id !== highlightedItem?.seriesId
                  ? 0.5
                  : 1,
            }}
            variant="caption"
          >{`${item.label}`}</Typography>
        </Stack>
      ))}
    </Box>
  );
};

export default HighlightedLegend;
